import { getTokenAsync } from "@coworker/app/src/hooks/API/getAuthToken";
import { HttpError } from "@coworker/apprestructured/src/shared/types/exception";

export async function createAuthorizationHeader() {
  const token = await getTokenAsync();
  if (!token) {
    throw new Error("Failed to get token");
  }

  return { Authorization: `Bearer ${token}` };
}

export function throwIfNotOk(response: Response) {
  if (!response.ok) {
    throw new HttpError(response.status, response.statusText);
  }
}

export async function toJson<T>(response: Response) {
  throwIfNotOk(response);
  return (await response.json()) as T;
}
